// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1ufIa","rootSmall":"AddTileButton_rootSmall__2Nogp"};